const reviews = {
  top_reviews: [
    {
      id: 0,
      date_created: '2024-05-01T12:00:00.00Z',
      public_review: 'review--0--review',
      user: {
        first_name: 'Lexi',
        last_name: 'L',
        has_photo: false,
      },
      rating: 5,
      listing_headline: 'review--0--headline',
    },
    {
      id: 1,
      date_created: '2024-05-01T12:00:00.00Z',
      public_review: 'review--1--review',
      user: {
        first_name: 'Miketa',
        last_name: 'W',
        has_photo: false,
      },
      rating: 5,
      listing_headline: 'review--1--headline',
    },
    {
      id: 2,
      date_created: '2024-05-01T12:00:00.00Z',
      public_review: 'review--2--review',
      user: {
        first_name: 'Kelsey',
        last_name: 'A',
        has_photo: false,
      },
      rating: 5,
      listing_headline: 'review--2--headline',
    },
    {
      id: 3,
      date_created: '2024-04-01T12:00:00.00Z',
      public_review: 'review--3--review',
      user: {
        first_name: 'Tierra',
        last_name: 'E',
        has_photo: false,
      },
      rating: 5,
      listing_headline: 'review--3--headline',
    },
    {
      id: 4,
      date_created: '2024-04-01T12:00:00.00Z',
      public_review: 'review--4--review',
      user: {
        first_name: 'Kristen',
        last_name: 'C',
        has_photo: false,
      },
      rating: 5,
      listing_headline: 'review--4--headline',
    },
    {
      id: 5,
      date_created: '2024-04-01T12:00:00.00Z',
      public_review: 'review--5--review',
      user: {
        first_name: 'Kathleen',
        last_name: 'O',
        has_photo: false,
      },
      rating: 5,
      listing_headline: 'review--5--headline',
    },
  ],
};

export default reviews;
